const styles = (theme) => ({
  root: {
    overflowX: 'hidden',
    overflowY: 'auto',
    maxHeight: 550,
    padding: theme.spacing(1)
  }
})

export {
  styles
}
